import React, {useState} from 'react';
import {
    Alert,
    Button,
    Container,
    Grid,
    Paper,
    TextField,
    Typography,
} from '@mui/material';
import axios from 'axios';
import {OBSERVATORIUM_API_URL, setAuthToken} from '../api';
import {useNavigate} from 'react-router-dom';

const Login = ({setAuth}) => {
    const [formData, setFormData] = useState({email: '', password: ''});
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const handleChange = (e) => {
        setFormData({...formData, [e.target.name]: e.target.value});
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        try {
            // Login against Observatorium
            const response = await axios.post(`${OBSERVATORIUM_API_URL}/accounts/login/`, formData);
            const token = response.data.token;

            // Store token and set auth header for all subsequent requests
            localStorage.setItem('token', token);
            setAuthToken(token);

            setAuth(true);
            navigate('/');
        } catch (err) {
            setError('Login Failed. Please check your credentials and ensure you are a registered researcher.');
            console.error('Login failed:', err.response?.data || err.message);
        }
    };

    return (
        <Container maxWidth="sm">
            <Paper elevation={3} sx={{p: 4, mt: 8}}>
                <Typography variant="h4" component="h1" gutterBottom>
                    Researcher Login
                </Typography>
                <form onSubmit={handleSubmit}>
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <TextField
                                label="Email"
                                name="email"
                                type="email"
                                value={formData.email}
                                onChange={handleChange}
                                fullWidth
                                required
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                label="Password"
                                name="password"
                                type="password"
                                value={formData.password}
                                onChange={handleChange}
                                fullWidth
                                required
                            />
                        </Grid>
                        {error && (
                            <Grid item xs={12}>
                                <Alert severity="error">{error}</Alert>
                            </Grid>
                        )}
                        <Grid item xs={12}>
                            <Button type="submit" variant="contained" color="primary" fullWidth>
                                Login
                            </Button>
                        </Grid>
                    </Grid>
                </form>
            </Paper>
        </Container>
    );
};

export default Login;